import * as Yup from "yup";

export const loginSchema = Yup.object().shape({
  username: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(3, "Password must be at least 3 characters")
    .required("Password is required"),
});

export type LoginFormType = Yup.InferType<typeof loginSchema>;